import { render, staticRenderFns } from "./suppliersDialog.vue?vue&type=template&id=8a48a32c"
import script from "./suppliersDialog.vue?vue&type=script&lang=js"
export * from "./suppliersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports